export enum CommandType {
  IS_ALIVE = 'IS_ALIVE',
  CALL_INIT = 'CALL_INIT',
  CALL_END = 'CALL_END',
  CALL_BUSY = 'CALL_BUSY',
  CALL_PRESS = 'CALL_PRESS',
  CALL_FAILED = 'CALL_FAILED',
  INFO_DEVICE = 'INFO_DEVICE',
  INFO_BOOT = 'INFO_BOOT',
  INFO_REBOOT = 'INFO_REBOOT',
  INFO_FOTA_FAIL = 'INFO_FOTA_FAIL',
}
